import { Injectable } from '@angular/core';
import 'rxjs/Rx';
import { ApiService } from '../authentication/guards/api.service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class UnitService {
    constructor(private apiService: ApiService) { }

    create(unit) {
        return this.apiService.post('/unit', unit).map(data => data);
    }

    getListOfUnit(id) {
        return this.apiService.get('/unitlist/' + id).map(data => data);
    }

    getUnitById(id) {
        return this.apiService.get('/unit/' + id).map(data => data);
    }

    delete(id, appid, UnitUserDeleteFlag) {
        return this.apiService.delete('/unit/' + appid + '/app/' + id+ '/flag/' + UnitUserDeleteFlag).map(data => data);
    }

    deleteUnitUser(id, appid, UserIdArr) {
        return this.apiService.post('/unituser/' + appid + '/app/' + id, UserIdArr).map(data => data);
    }

    GetAllUnitList(appIds: String) {
        return this.apiService.get('/unitidnamelist?ids=' + appIds).map(data => data);
    }

    GetAllUserUnitList(appIds: String) {
        return this.apiService.get('/userunitidnamelist?ids=' + appIds).map(data => data);
    }

    GetUnitDetail(unitId: string) {
        return this.apiService.get('/unitdetail/' + unitId).map(data => data);
    }
    // GetUnitListByUserId() {
    //     return this.apiService.get('/unitidnamelistbyuserid').map(data => data);
    // }

    GetCategoryUnits(snCategoryIds, snModuleType){
        var snCurrentAppId = JSON.parse(window.sessionStorage['selectedApp']);
        return this.apiService.post('/getCategoryUnits/'+snCurrentAppId["Id"]+'/'+snModuleType,{'CategoryId': snCategoryIds,'ModuleId':'3'}).map(data => data);
        //return this.apiService.post('/getCategoryUnits/'+snCategoryId+'/'+appid['Id']).map(data => data);
    }
}


// WEBPACK FOOTER //
// D:/projects/4164_AppsPotr_Backend/production/CMS_prod/src/app/services/unit-management/unit-management.ts